/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_nA_110_65 as Componente_nA_110_65,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function NombreMarca(e) {
  let t = (0, ReactCompiler.c)(17),
    { f: n, setF: r } = e,
    i;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = (
        <span
          className={`text-xs text-(--text)`}
          children={`Nombre de la aplicación`}
        />
      )),
      (t[0] = i))
    : (i = t[0]);
  let a;
  t[1] !== n || t[2] !== r
    ? ((a = (e) =>
        r({
          ...n,
          nombreApp: e.target.value,
        })),
      (t[1] = n),
      (t[2] = r),
      (t[3] = a))
    : (a = t[3]);
  let o;
  t[4] !== n.nombreApp || t[5] !== a
    ? ((o = (
        <label
          className={`flex flex-col gap-1`}
          children={[
            i,
            <input
              className={Lo}
              value={n.nombreApp}
              maxLength={60}
              onChange={a}
            />,
          ]}
        />
      )),
      (t[4] = n.nombreApp),
      (t[5] = a),
      (t[6] = o))
    : (o = t[6]);
  let s;
  t[7] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((s = (
        <span
          className={`text-xs text-(--text)`}
          children={`Nombre de la empresa`}
        />
      )),
      (t[7] = s))
    : (s = t[7]);
  let c;
  t[8] !== n || t[9] !== r
    ? ((c = (e) =>
        r({
          ...n,
          nombreEmpresa: e.target.value,
        })),
      (t[8] = n),
      (t[9] = r),
      (t[10] = c))
    : (c = t[10]);
  let l;
  t[11] !== n.nombreEmpresa || t[12] !== c
    ? ((l = (
        <label
          className={`flex flex-col gap-1`}
          children={[
            s,
            <input
              className={Lo}
              value={n.nombreEmpresa}
              maxLength={100}
              placeholder={`Opcional`}
              onChange={c}
            />,
          ]}
        />
      )),
      (t[11] = n.nombreEmpresa),
      (t[12] = c),
      (t[13] = l))
    : (l = t[13]);
  let u;
  return (
    t[14] !== o || t[15] !== l
      ? ((u = (
          <Componente_nA_110_65
            titulo={`Nombre`}
            ayuda={`Se ve en la pestaña del navegador, en los correos y al instalar la aplicación en el teléfono.`}
            children={[o, l]}
          />
        )),
        (t[14] = o),
        (t[15] = l),
        (t[16] = u))
      : (u = t[16]),
    u
  );
}
